module.exports = __webpack_public_path__ + "static/img/vipban.6106bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fl20210204/vipban.png
// module id = 85eU
// module chunks = 0